const config = {
  env: 'PROD',
  firebaseConfig: {
    apiKey: 'AIzaSyAV82BRYnkAHqDguBc10Akei6gblRKcejU',
    authDomain: 'elret-prod.firebaseapp.com',
    projectId: 'elret-prod',
    storageBucket: 'elret-prod.firebasestorage.app',
    messagingSenderId: '920954633910',
    appId: '1:920954633910:web:70edcfbe812f1978657017',
    measurementId: 'G-9LFN5EDB32'
  },
  siteId: 'elret-prod',
  uiBaseUrl: 'https://elret.ro',
  apiBaseUrl: 'https://elret-prod.web.app/api/',
  fiServEnvUrl: 'https://ais-ui.fiservapps.com/alldata/',
  intercomAppId: 'qlijpicu',
  sentryConfiguration: {
    dsn: 'https://9903b092d7b46346e674b33a1a8ea90d@o4509571123052544.ingest.de.sentry.io/4509571129081936',
  },
};

export default config;
